import { useAuth } from "../../contexts/AuthContext";
import { SERVICES, PORTFOLIO, PACKAGES } from "../../data/content";
import {
  LayoutDashboard,
  Sparkles,
  Camera,
  Crown,
  ArrowRight,
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

// ---------------------------------------------------------------------------
// Stat card
// ---------------------------------------------------------------------------
function StatCard({ icon: Icon, label, value, to, color }) {
  const navigate = useNavigate();

  return (
    <Card className="bg-[#0a0908] border-[#d4af37]/20 hover:border-[#d4af37]/40 transition-all duration-300 group">
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <CardTitle className="text-sm font-medium text-[#a6a196]">
          {label}
        </CardTitle>
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${color}15` }}
        >
          <Icon className="w-4 h-4" style={{ color }} />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold text-[#fdfbf7]">{value}</div>
        {to && (
          <Button
            variant="link"
            onClick={() => navigate(to)}
            className="px-0 h-auto mt-2 text-xs text-[#d4af37]/60 hover:text-[#d4af37] group-hover:opacity-100 opacity-0 transition-all duration-300"
          >
            Kelola {label.toLowerCase()}
            <ArrowRight className="w-3 h-3 ml-1" />
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

// ---------------------------------------------------------------------------
// Dashboard
// ---------------------------------------------------------------------------
export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const stats = [
    {
      icon: Camera,
      label: "Item Portfolio",
      value: PORTFOLIO.length,
      to: "/admin/portfolio",
      color: "#d4af37",
    },
    {
      icon: Sparkles,
      label: "Services",
      value: SERVICES.length,
      to: "/admin/services",
      color: "#f0c950",
    },
    {
      icon: Crown,
      label: "Packages",
      value: PACKAGES.length,
      to: "/admin/packages",
      color: "#e8d9b4",
    },
  ];

  const displayName = user?.displayName || "Admin";

  return (
    <div className="space-y-8 max-w-5xl mx-auto">
      {/* Welcome */}
      <div>
        <div className="flex items-center gap-3 mb-1">
          <div className="w-1 h-6 bg-[#d4af37] rounded-full" />
          <h1 className="text-2xl font-display text-[#fdfbf7]">
            Selamat datang kembali, {displayName.split(" ")[0]}
          </h1>
        </div>
        <p className="text-sm text-[#a6a196] ml-4">
          Kelola konten website Sanggar Rias Adibah dari sini.
        </p>
      </div>

      {/* Stats grid */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </div>

      {/* Quick links */}
      <Card className="bg-[#0a0908] border-[#d4af37]/20">
        <CardHeader>
          <CardTitle className="text-sm font-medium text-[#a6a196] flex items-center gap-2">
            <LayoutDashboard className="w-4 h-4 text-[#d4af37]" />
            Aksi Cepat
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { label: "Kelola Layanan", to: "/admin/services" },
              { label: "Kelola Portfolio", to: "/admin/portfolio" },
              { label: "Kelola Paket", to: "/admin/packages" },
              { label: "Kelola FAQ", to: "/admin/faqs" },
              { label: "Kelola Testimoni", to: "/admin/testimonials" },
              { label: "Pengaturan Situs", to: "/admin/settings" },
            ].map((link) => (
              <Button
                key={link.to}
                variant="outline"
                onClick={() => navigate(link.to)}
                className="justify-between bg-[#15120f] border-[#d4af37]/15 hover:border-[#d4af37]/30 text-[#fdfbf7] hover:text-[#d4af37] transition-all duration-200 group"
              >
                <span className="text-sm">{link.label}</span>
                <ArrowRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
